'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _KEY_MAP;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* injects from baggage-loader */

var APPEND_RIGHT_CONNECTED = exports.APPEND_RIGHT_CONNECTED = 'APPEND_RIGHT_CONNECTED';
var APPEND_RIGHT = exports.APPEND_RIGHT = 'APPEND_RIGHT';
var APPEND_BOTTOM_CONNECTED = exports.APPEND_BOTTOM_CONNECTED = 'APPEND_BOTTOM_CONNECTED';

var KEY_MAP = exports.KEY_MAP = (_KEY_MAP = {}, _defineProperty(_KEY_MAP, APPEND_RIGHT, 'shift+tab'), _defineProperty(_KEY_MAP, APPEND_RIGHT_CONNECTED, 'tab'), _defineProperty(_KEY_MAP, APPEND_BOTTOM_CONNECTED, ['ctrl+enter', 'command+enter']), _KEY_MAP);


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/ProjectView/NodeView/hotkeys.js
// module id = 598
// module chunks = 1